import { Badge, Text } from "@mantine/core";
import { IconFileAlert } from "@tabler/icons-react";
import React from "react";
import { getSkypointExpiringDocuments } from "../../../services/skypointAlerts";
import SkypointAlertsTablePage from "./SkypointAlertsTablePage";

const userTypeColor = (t) =>
  t === "Client" ? "blue" : t === "Staff" ? "violet" : t === "Facility" ? "teal" : "gray";

const columns = [
  {
    key: "provider",
    header: "Provider",
    width: 200,
    render: (item) => (
      <Text weight={500} size="sm">
        {item.providerName}
      </Text>
    ),
  },
  {
    key: "userType",
    header: "User Type",
    width: 110,
    render: (item) => (
      <Badge variant="light" size="sm" color={userTypeColor(item.userType)}>
        {item.userType || "—"}
      </Badge>
    ),
  },
  {
    key: "name",
    header: "Name",
    width: 200,
    render: (item) => (
      <Text size="sm" color={item.ownerName ? "dark" : "dimmed"}>
        {item.ownerName || "—"}
      </Text>
    ),
  },
  {
    key: "document",
    header: "Document",
    render: (item) => <Text size="sm">{item.documentName}</Text>,
  },
  {
    key: "expiresIn",
    header: "Expires In",
    width: 120,
    render: (item) => (
      <Badge
        color={
          item.daysUntilExpiry <= 7
            ? "red"
            : item.daysUntilExpiry <= 14
              ? "orange"
              : "yellow"
        }
        variant="light"
        size="sm"
      >
        {item.daysUntilExpiry} {item.daysUntilExpiry === 1 ? "day" : "days"}
      </Badge>
    ),
  },
  {
    key: "expires",
    header: "Expires On",
    width: 130,
    render: (item) => (
      <Text size="xs" color="dimmed">
        {item.relatedDate ? new Date(item.relatedDate).toLocaleDateString() : "—"}
      </Text>
    ),
  },
];

const ExpiringDocuments = ({ isSidebarOpen }) => (
  <SkypointAlertsTablePage
    isSidebarOpen={isSidebarOpen}
    title="Expiring Documents"
    description="Documents whose expiry date is within the next 30 days"
    Icon={IconFileAlert}
    iconColor="#F79009"
    iconBg="#FFF6ED"
    columns={columns}
    stateSelector={(state) => state?.skypointAlerts?.expiringDocuments}
    fetcher={getSkypointExpiringDocuments}
    emptyMessage="No documents expiring in the next 30 days."
    itemUnit="document"
  />
);

export default ExpiringDocuments;
